import { memo, useState } from "react";
import { useFormContext } from "react-hook-form";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Checkbox,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@/common/components";

export const ScheduleNormsCard = memo(() => {
  const form = useFormContext();

  const [isMoratoriumActive, setIsMoratoriumActive] = useState(false);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Графики и нормативы</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 md:space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 items-start">
          <FormField
            control={form.control}
            name="standartTimeLoading"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Норматив на погрузку (сутки)</FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    placeholder="Количество суток"
                    {...field}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="standartTimeUnloading"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Норматив на выгрузку (сутки)</FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    placeholder="Количество суток"
                    {...field}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="penalty"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Штраф за превышение сроков норматива</FormLabel>
                <FormControl>
                  <Input
                    placeholder="руб./сутки"
                    type="number"
                    step="0.01"
                    {...field}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value)}
                    disabled={isMoratoriumActive}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div className="p-4 border rounded-lg bg-muted/20">
          <div className="flex flex-col space-y-2">
            <FormLabel>Мораторий</FormLabel>
            <div className="flex gap-2 items-center">
              <FormField
                control={form.control}
                name="moratorium"
                render={({ field }) => (
                  <Checkbox
                    id="moratorium"
                    checked={!!field.value}
                    onCheckedChange={(checked: boolean) => {
                      field.onChange(checked);
                      setIsMoratoriumActive(checked);
                      if (checked) {
                        form.setValue("penalty", 0, { shouldValidate: true, shouldDirty: true });
                      }
                    }}
                  />
                )}
              />
              <div className="space-y-1 leading-none">
                <FormLabel htmlFor="moratorium" className="cursor-pointer">
                  При активации моратория штрафы не применяются
                </FormLabel>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
});
